import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'

import {Status} from '@/components'
import {TagType} from '@/components/dumb/Tag/props'

import styles from './OutletStatus.scss'

export const OutletStatus: React.FC<{isActive: boolean}> = observer(({isActive}) => {
    const { t } = useTranslation()
    return (
        <Status
            className={styles.status}
            status={isActive ? t('OutletStatus.status.active') : t('OutletStatus.status.closed')}
            type={isActive ? TagType.Success : TagType.Disabled}
            iconType={isActive ? 'check' : 'close'}
        />
    )
})
